import React from 'react';
import './Accordian.css';
import { useLanguage } from '../context/LanguageContext';
import MyAccordian from './MyAccordian';

const Accordian = () => {
  const { t } = useLanguage();

  return (
    <section className="section-tight">
      <div className="container">
        <div className="section-title center">
          <div className="eyebrow">Innovative Horizons</div>
          <h2>{t.faqs.title}</h2>
          <p>{t.faqs.subtitle}</p>
        </div>
        <div className="faq-stack">
          {t.faqQuestions.map((item) => <MyAccordian key={item.id} {...item} />)}
        </div>
      </div>
    </section>
  );
};

export default Accordian;
